(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pc-information-design]').forEach(section => {
      if (section.hasAttribute('data-info-ready')) return;
      section.setAttribute('data-info-ready', '');
      const main = document.querySelector('[data-ap201-reference]');
      const config = main?.querySelector('.a31-config');
      const gallery = main?.querySelector('.a31-gallery');
      const photo = section.querySelector('[data-info-main-image]');
      const thumbs = section.querySelector('[data-info-thumbs]');
      const trigger = key => main?.querySelector(key === 'case' ? '.a31-case-trigger' : `[data-a31-component-key="${key}"]`);
      const label = key => (trigger(key)?.querySelector('.elite-pc-trigger__value')?.textContent || '').replace(/\s+/g, ' ').trim();
      const write = (target, text) => { if (target && target.textContent !== text) target.textContent = text; };
      const safeImage = value => {
        try {
          const url = new URL(value, location.origin);
          return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com')) ? url.href : '';
        } catch { return ''; }
      };
      const largeImage = value => {
        const source = safeImage(value);
        if (!source) return '';
        const url = new URL(source);
        url.searchParams.set('width', '900');
        return url.href;
      };
      const imageIdentity = value => {
        const source = safeImage(value);
        if (!source) return '';
        const url = new URL(source);
        return `${url.origin}${url.pathname}?v=${url.searchParams.get('v') || ''}`;
      };
      const responsivePhoto = (image, source) => {
        if (imageIdentity(image.src) === imageIdentity(source)) return;
        const candidate = width => {
          const url = new URL(source);
          url.searchParams.set('width', String(width));
          return url.href;
        };
        image.sizes ||= '(max-width: 700px) 90vw, 45vw';
        image.srcset = [400, 600, 900].map(width => `${candidate(width)} ${width}w`).join(', ');
        image.src = candidate(900);
      };
      const selectPhoto = button => {
        const source = safeImage(button?.dataset.infoPhoto);
        if (!source || !photo) return;
        responsivePhoto(photo, source);
        thumbs.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      thumbs.addEventListener('click', event => {
        const button = event.target.closest('[data-info-photo]');
        if (button) selectPhoto(button);
      });
      // Keep the server-rendered responsive gallery on the first visit. Only
      // replace it when the selected case actually supplies different photos.
      let imageSignature = JSON.stringify([...thumbs.querySelectorAll('[data-info-photo]')]
        .map(button => imageIdentity(button.dataset.infoPhoto)).filter(Boolean).slice(0, 6));
      const syncGallery = () => {
        if (!gallery || !photo) return;
        const sources = [...gallery.querySelectorAll('.a31-thumb img')].map(image => largeImage(image.src)).filter(Boolean);
        if (!sources.length) {
          const image = gallery.querySelector('.a31-gallery-main img');
          if (image) sources.push(largeImage(image.src));
        }
        const unique = [...new Set(sources.filter(Boolean))].slice(0, 6);
        const signature = JSON.stringify(unique.map(imageIdentity));
        if (!unique.length || imageSignature === signature) return;
        imageSignature = signature;
        thumbs.replaceChildren(...unique.map((source, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.infoPhoto = source;
          button.setAttribute('aria-label', `View case photo ${index + 1}`);
          const image = document.createElement('img');
          const small = new URL(source); small.searchParams.set('width', '180');
          image.src = small.href; image.alt = ''; image.loading = 'lazy';
          button.append(image);
          return button;
        }));
        photo.alt = label('case') || 'Selected PC case';
        selectPhoto(thumbs.querySelector('button'));
        section.querySelectorAll('[data-info-case-image]').forEach(image => {
          responsivePhoto(image, unique[0]); image.alt = photo.alt;
        });
        thumbs.hidden = unique.length < 2;
      };
      const syncSelection = () => {
        section.querySelectorAll('[data-info-spec]').forEach(target => write(target, label(target.dataset.infoSpec) || 'Not selected'));
        const warrantyTitle = main?.querySelector('[data-ap201-warranty-title]')?.textContent.trim();
        const warrantyDetail = main?.querySelector('[data-ap201-warranty-details]')?.textContent.trim();
        const chosenWarranty = label('warranty');
        const plan = chosenWarranty.match(/\b(bronze|silver|gold|platinum|diamond)\b/i)?.[1]?.toLowerCase() || 'bronze';
        const years = { bronze:1, silver:2, gold:3, platinum:4, diamond:5 }[plan];
        write(section.querySelector('[data-info-warranty-title]'), warrantyTitle || `${plan[0].toUpperCase()}${plan.slice(1)} warranty`);
        write(section.querySelector('[data-info-warranty-detail]'), warrantyDetail || `${years} ${years === 1 ? 'year' : 'years'} – parts, labour & return`);
        section.querySelectorAll('[data-info-plan]').forEach(item => {
          item.setAttribute('aria-pressed', String(item.dataset.infoPlan === plan));
          if (item.tagName === 'BUTTON') item.disabled = main?.dataset.elitePcCatalogReady !== 'true';
          if (item.dataset.infoPlan === plan) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        const software = label('operating-system') || label('windows_key') || label('windows');
        write(section.querySelector('[data-info-software]'), software && !/^(none|no |not selected)/i.test(software)
          ? `${software} and the drivers for your selected components are set up for your build.`
          : 'Software setup follows your selected operating system option. Check the configurator for what is included.');
        const form = section.querySelector('[data-product-question-form]');
        const title = main?.querySelector('[data-ap201-build-title]')?.textContent.trim();
        if (form && title) form.querySelector('[name="contact[product]"]').value = title;
        if (form) form.querySelector('[name="contact[product_url]"]').value = location.href;
        syncGallery();
      };
      // Observe rendered selections only. This adds no catalogue or compatibility requests.
      let frame;
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; syncSelection(); });
      };
      if (config) new MutationObserver(schedule).observe(config, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-elite-selected-sku'] });
      if (gallery) new MutationObserver(schedule).observe(gallery, { childList:true, subtree:true, attributes:true, attributeFilter:['src'] });
      syncSelection();

      const widget = section.querySelector('[data-reviews-widget]');
      if (widget) {
        const principles = widget.querySelector('.epc-reviews-principles');
        const distribution = document.createElement('div');
        distribution.className = 'epc-info__distribution';
        distribution.setAttribute('aria-label', 'Rating distribution');
        principles.after(distribution);
        const updateRatings = () => {
          let counts;
          try { counts = JSON.parse(widget.dataset.ratingCounts || '[]'); } catch { counts = []; }
          const total = counts.reduce((sum, count) => sum + count, 0);
          distribution.hidden = !total;
          principles.hidden = !!total;
          distribution.replaceChildren(...[5,4,3,2,1].map(score => {
            const row = document.createElement('div');
            const name = document.createElement('span'); name.textContent = `${score} ${score === 1 ? 'star' : 'stars'}`;
            const meter = document.createElement('meter'); meter.min = 0; meter.max = total || 1; meter.value = counts[score - 1] || 0;
            meter.setAttribute('aria-label', `${score} stars: ${meter.value} reviews`);
            const share = document.createElement('span'); share.textContent = `${total ? Math.round(meter.value / total * 100) : 0}%`;
            row.append(name,meter,share); return row;
          }));
        };
        new MutationObserver(updateRatings).observe(widget, { attributes:true, attributeFilter:['data-rating-counts'] });
        updateRatings();
        const reviewForm = widget.querySelector('.epc-review-form-panel');
        const close = document.createElement('button');
        close.type = 'button'; close.className = 'epc-info__button epc-info__button--outline epc-info__review-back'; close.textContent = 'Back to reviews';
        const showForm = open => {
          reviewForm.classList.toggle('is-open', open);
          widget.querySelector('.epc-reviews-main').hidden = open;
          widget.querySelector('.epc-reviews-hero').hidden = open;
          if (open) {
            reviewForm.scrollIntoView({ block:'nearest' });
            reviewForm.querySelector('input:not([type="hidden"])')?.focus({ preventScroll:true });
          } else widget.querySelector('.epc-reviews-hero a').focus({ preventScroll:true });
        };
        close.addEventListener('click', () => showForm(false));
        reviewForm.prepend(close);
        widget.querySelectorAll('a[href="#write-review"]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); showForm(true); }));
        if (location.hash === '#write-review' || reviewForm.querySelector('[data-form-result]')) showForm(true);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
